import IMask from "imask";
import {type InputMaskElement} from "imask";

export const setPhoneMask = (el: InputMaskElement): void => {
  const phoneMaskOptions = {
    mask: "+{7} (000) 000-00-00",
    prepare: (appended: string, masked: { value: string }) => {
      if (appended === "8" && masked.value === "") {
        return "+7";
      }
      return appended;
    },
    overwrite: true,
    autofix: true,
  };

  IMask(el, phoneMaskOptions)
}

export const setInnMask = (el: InputMaskElement): void => {
  const innMaskOptions = {
    mask: [
      {
        mask: "0000000000",
      },
      {
        mask: "000000000000",
      },
    ],
  };

  IMask(el, innMaskOptions);
}

export const init = () => {
  const textPhoneSelectors = document?.querySelectorAll(
    "[data-mask-phone-text]"
  );
  const inputPhoneSelectors =
    document.querySelectorAll<HTMLElement>("input[type='tel']")!;
  const innInputSelectors =
    document?.querySelectorAll<HTMLElement>("[data-inn]");

  inputPhoneSelectors?.forEach((el) => setPhoneMask(el));

  innInputSelectors?.forEach((el) => setInnMask(el));

  textPhoneSelectors?.forEach((el) => {
    el.textContent = formatPhoneNumber(el.textContent!);
  });
};

export const formatPhoneNumber = (s: string, plus = true) => {
  if (!s) return "Телефон не указан";

  const matches = /^(\+?7|8)(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(s);

  // Skip, if invalid supported phone format (+70000000000, 70000000000 or 80000000000)
  if (null === matches) {
    return s;
  }

  const startsWith = plus ? "+7" : "8";

  return `${startsWith} (${matches[2]}) ${matches[3]}-${matches[4]}-${matches[5]}`;
};
